import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@cibli/shared';
import { Mail, MessageSquareWarning } from 'lucide-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

type SmsErrorModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSendByEmail: () => void;
  isLoading?: boolean;
};

const SmsErrorModal = ({ open, onOpenChange, onSendByEmail, isLoading }: SmsErrorModalProps) => {
  const { t } = useTranslation();

  const handleSendByEmail = useCallback(() => {
    onSendByEmail();
  }, [onSendByEmail]);

  const handleCancel = useCallback(() => {
    onOpenChange(false);
  }, [onOpenChange]);

  return (
    <AlertDialog open={open} onOpenChange={handleCancel}>
      <AlertDialogContent className="sm:max-w-xl">
        <AlertDialogHeader>
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center">
              <MessageSquareWarning className="h-8 w-8 text-destructive" aria-hidden="true" />
            </div>
          </div>
          <AlertDialogTitle className="text-2xl font-bold text-center">
            {t('SmsErrorModal.title')}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-lg text-center">
            {t('SmsErrorModal.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="py-4">
          <p className="text-muted-foreground text-center">{t('SmsErrorModal.suggestion')}</p>
        </div>
        <AlertDialogFooter className="gap-3">
          <Button variant="outline" size="lg" onClick={handleCancel}>
            {t('common.cancel')}
          </Button>
          <Button size="lg" onClick={handleSendByEmail} disabled={isLoading} className="gap-2">
            <Mail className="h-5 w-5" aria-hidden="true" />
            {isLoading ? t('SmsErrorModal.sending') : t('SmsErrorModal.sendByEmail')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SmsErrorModal;
